import styled from "styled-components";
import { device, mq } from "lib/media-query";

export const FooterRow = styled.section`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 10px;

    ${mq.to(device.TABLET_PLUS)`
  grid-template-columns: repeat(4, 1fr);
  `}

    ${mq.to(device.TABLET)`
  grid-template-columns: repeat(3, 1fr);
  `}

  ${mq.to(device.MOBILE)`
  grid-template-columns: repeat(2, 1fr);
  `}
`;
